<template>
    <h4 class="alert-heading">
        <slot />
    </h4>
</template>

<script>
export default {

    name: 'AlertHeading'

};
</script>
